// import { useState, useEffect, useRef, useContext } from 'react';
// import { useParams } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import EmojiPicker from 'emoji-picker-react';
// import AudioMessageRecorder from "./AudioMessageRecorder";
// import defaultUrlImage from '../media/url-default.jpg';
// import { find as linkifyFind } from 'linkifyjs';
// import FileUploader from './FileUploader';
// import Cookies from 'js-cookie';
// import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';

// import { useChatApi } from '../Services/ChatApiProvider';

// const ChatInputContainer = ({
//   isChatActive,
//   request,
//   onBlur,
//   onRequestChange
// }) => {
//   const { channelId } = useParams();

//   const { userName, userEmail, createUserName, createUserEmail, sendMessage, channelSettings, isOnline, userPhone, createUserPhone, isHydrated } = useChatApi();

//   const [isButtonEnabled, setIsButtonEnabled] = useState(true);
//   const [pendingAudioData, setPendingAudioData] = useState(null);
//   const [shouldRender, setShouldRender] = useState(false);

//   const [email, setEmail] = useState('');
//   const [emailError, setEmailError] = useState(false);
//   const [inputFocused, setInputFocused] = useState(false);
//   const [emailSubmitted, setEmailSubmitted] = useState(false);

//   // ====================== Phone field functionality ====================
//   const [phone, setPhone] = useState('');
//   const [phoneError, setPhoneError] = useState(false);
//   const [phoneSubmitted, setPhoneSubmitted] = useState(false);
//   const [showPhoneField, setShowPhoneField] = useState(false);
//   const [phoneRequired, setPhoneRequired] = useState(false);

//   const inputContainerRef = useRef(null);

//   const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
//   const [showRecorder, setShowRecorder] = useState(false);
//   const [clearAudio, setClearAudio] = useState(false);
//   const [audioMessageSubmitted, setAudioMessageSubmitted] = useState(false);

//   // ---------------- NEW: For URL preview data ------------------
//   const [urlPreviewData, setUrlPreviewData] = useState(null);
//   // -------------------------------------------------------------

//   // ---------- For pre-uploaded files [FileUploader Changes] ----------
//   const [preuploadedFiles, setPreuploadedFiles] = useState([]);
//   const [clearUploader, setClearUploader] = useState(false);

//   const [firstMessageSent, setFirstMessageSent] = useState(false);

//   // keep the button alive when new audio arrives (covers “subsequent audio” stuck case)
//   useEffect(() => {
//     if (pendingAudioData) setIsButtonEnabled(true);
//   }, [pendingAudioData]);

//   //  ====================== Name field functionality ====================
//   const [name, setName] = useState('');
//   const [nameError, setNameError] = useState(false);
//   const [nameSubmitted, setNameSubmitted] = useState(false);

//   const specialCharRegex = /[<>\/\\[\]{}]+/; // Disallow these special symbols

//   const [showNameField, setShowNameField] = useState(false);
//   const [showEmailField, setShowEmailField] = useState(false);

//   useEffect(() => {
//    if (!isHydrated) return;
//    if (userName && String(userName).trim().length > 0) {
//       setNameSubmitted(true);
//       setShowNameField(false);
//     } else if (channelSettings?.requestName === true) {
//       setShowNameField(true);
//       setNameSubmitted(false);
//     } else {
//       setShowNameField(false);
//       setNameSubmitted(false);
//     }
//   }, [isHydrated, channelSettings?.requestName, userName]);

//   useEffect(() => {
//     if (!isHydrated) return;
//     if (userEmail && String(userEmail).trim().length > 0) {
//       setEmailSubmitted(true);
//       setShowEmailField(false);
//     } else if (channelSettings?.requestEmail === true) {
//       setShowEmailField(true);
//       setEmailSubmitted(false);
//     } else {
//       setShowEmailField(false);
//       setEmailSubmitted(false);
//     }
//   }, [isHydrated, channelSettings?.requestEmail, userEmail]);

//   useEffect(() => {
//     if (!isHydrated) return;
//     if (userPhone && String(userPhone).trim().length > 0) {
//       setPhoneSubmitted(true);
//       setShowPhoneField(false);
//       setPhoneRequired(false);
//     } else {
//       setShowPhoneField(Boolean(channelSettings?.requestPhone));
//       setPhoneRequired(Boolean(channelSettings?.requirePhone));
//       setPhoneSubmitted(false);
//     }
//   }, [isHydrated, channelSettings?.requestPhone, channelSettings?.requirePhone, userPhone]);

//   // ======================= MESSAGE FLAGS =======================
//   const [messageFlags, setMessageFlags] = useState({
//     isSimpleText: true,
//     isURL: false,
//     isImageSingle: false,
//     isImageGallery: false,
//     isAudio: false,
//     isFile: false,
//     isVideo: false,
//     isHTML: false,
//   });

//   const setOnlyFlag = (flagName) => {
//     setMessageFlags({
//       isSimpleText: false,
//       isURL: false,
//       isImageSingle: false,
//       isImageGallery: false,
//       isAudio: false,
//       isFile: false,
//       isVideo: false,
//       isHTML: false,
//       [flagName]: true,
//     });
//   };

//   // ---------------------  Timed rendering logic  ----------------
//   useEffect(() => {
//     if (isChatActive && !shouldRender) {
//       const delayTimer = setTimeout(() => {
//         clearTimeout(delayTimer);
//         setShouldRender(true)
//       }, 400);
//     } else if (!isChatActive) {
//       setShouldRender(false);
//     }
//   }, [isChatActive, shouldRender]);

//   const isMobileRef = useRef(false);

//   useEffect(() => {
//     const ua = navigator.userAgent || navigator.vendor || window.opera;
//     const iPadOS = /Macintosh/.test(ua) && 'ontouchend' in document; // iPadOS 13+ pretends to be Mac
//     const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
//     const touchWindows = /Windows/i.test(ua) && navigator.maxTouchPoints > 1;
//     isMobileRef.current = mobileUA || iPadOS || touchWindows;
//   }, []);

//   // ---------------------  Clicking outside the input area -> remove "active"  ----------------
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (inputContainerRef.current && !inputContainerRef.current.contains(event.target)) {
//         setInputFocused(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   useEffect(() => {
//     let enabled = false;

//     const hasText = request.trim() !== '';
//     const hasName = (showNameField && name.trim() !== '' && !nameError) || !showNameField;
//     const hasEmail = (showEmailField && email.trim() !== '' && !emailError) || !showEmailField;
//     const hasAudio = pendingAudioData !== null;
//     const hasFiles = preuploadedFiles.length > 0;
//     // Phone gating (required vs optional)
//     let hasPhone = true;
//     if (showPhoneField) {
//       if (phoneRequired) {
//         hasPhone = isValidPhoneNumber(phone || '');
//       } else {
//         hasPhone = phone ? isValidPhoneNumber(phone) : true;
//       }
//     }

//     if (isChatActive && isOnline && hasEmail && hasName && hasPhone && (hasText || hasAudio || hasFiles)) {
//       enabled = true;
//     }
//     setIsButtonEnabled(enabled);
//   }, [
//     isChatActive,
//     request,
//     showEmailField,
//     email,
//     emailError,
//     showNameField,
//     name,
//     nameError,
//     pendingAudioData,
//     preuploadedFiles,
//     isOnline,
//     showPhoneField,
//     phone,
//     phoneError,
//     phoneRequired
//   ]);

//   // ==================== URL DETECTION & METADATA ====================

//   // 1. Detect any URL using linkifyjs' linkifyFind:
//   const detectURLInText = (text) => {
//     // linkifyFind returns an array of link objects, e.g. [{ type: 'url', value: 'https://...', href: '...' }, ...]
//     const foundLinks = linkifyFind(text);
//     // If at least one link object is found, return its "href" (the actual URL)
//     if (foundLinks.length > 0) {
//       return foundLinks[0].href; // e.g. "https://www.example.com"
//     }
//     return null;
//   };

//   // 2. Fetch metadata from remote site
//   const fetchURLMetadata = async (url) => {
//     try {
//       const response = await fetch(url);
//       // Might throw CORS error if site does not allow cross-origin fetch
//       const html = await response.text();

//       // DOMParser
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, "text/html");

//       // Attempt to grab an image
//       let imageTag =
//         doc.querySelector('meta[name="twitter:image"]') ||
//         doc.querySelector('meta[property="og:image"]');
//       let descriptionTag =
//         doc.querySelector('meta[name="description"]') ||
//         doc.querySelector('meta[property="og:description"]');
//       let titleTag = doc.querySelector('title');

//       const image = imageTag ? imageTag.getAttribute('content') : null;
//       const description = descriptionTag ? descriptionTag.getAttribute('content') : null;
//       const title = titleTag ? titleTag.innerText : null;

//       console.log('Retrieved image tag: ', image);
//       console.log('Retrieved description: ', description);
//       console.log('Retrieved title: ', title);

//       return { image, description, title };
//     } catch (error) {
//       console.warn("Fetching URL metadata failed:", error);
//       return null;
//     }
//   };

//   // 3. As user types, fetch metadata if a URL is found
//   const handleTextChange = async (e) => {
//     const newText = e.target.value;
//     onRequestChange(e);

//     const foundUrl = detectURLInText(newText);
//     if (foundUrl) {
//       const metaData = await fetchURLMetadata(foundUrl);

//       if (metaData) {
//         setUrlPreviewData({
//           url: foundUrl,
//           image: metaData.image,
//           description: metaData.description,
//           title: metaData.title,
//         });
//         setOnlyFlag('isURL');
//       }
//     } else {
//       // If user changed text and the URL is gone, reset
//       setUrlPreviewData(null);
//       setMessageFlags((oldFlags) => ({ ...oldFlags, isURL: false, isSimpleText: true }));
//     }
//   };

//   // ==================== SUBMIT (with small delay if needed) ====================
//   const handleEmailFocus = () => {
//     setEmailError(false);
//     setInputFocused(true);
//   };

//   // -------------- (1) Utility: Slightly transform text to linkify URLs ----------

//   // const handleKeyDown = (e) => {
//   //   if (e.key === 'Enter' && !e.shiftKey) {
//   //     e.preventDefault();
//   //     if (isButtonEnabled) {
//   //       handleSubmit();
//   //     }
//   //   }
//   // };
//   const handleKeyDown = (e) => {
//   if (e.key === 'Enter' && !e.shiftKey) {
//     // On mobile: never submit on Enter.
//     if (isMobileRef.current) {
//       // In the textarea, allow the default newline insertion.
//       if (e.target && e.target.tagName === 'TEXTAREA') return;

//       // In single-line inputs on mobile, ignore Enter entirely.
//       e.preventDefault();
//       return;
//     }

//     // Desktop: Enter = send, Shift+Enter = newline (handled by not hitting this branch)
//     e.preventDefault();
//     if (isButtonEnabled) handleSubmit();
//   }
// };

//   const handleSubmit = async () => {
//     // A. Pre-calc “need / has” for identity fields
//     const needName = (showNameField && !nameSubmitted);
//     const needEmail = (showEmailField && !emailSubmitted);
//     const needPhone = (showPhoneField && !phoneSubmitted);

//     const hasNameInput = name.trim() !== '';
//     const hasEmailInput = email.trim() !== '';
//     const hasPhoneInput = Boolean(phone);
//     const text = request.trim();

//     // B. If identity fields are requested and user typed something, validate & persist
//     if ((needName || needEmail || needPhone) && (hasNameInput || hasEmailInput || hasPhoneInput || text || pendingAudioData || preuploadedFiles.length > 0)) {

//       // name
//       if (hasNameInput && specialCharRegex.test(name)) {
//         setNameError(true);
//         return;
//       } else {
//         setNameError(false);
//       }

//       // email
//       if (hasEmailInput) {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(email.trim())) {
//           setEmailError(true);
//           return;
//         } else {
//           setEmailError(false);
//         }
//       }

//       // phone
//       if (needPhone && phoneRequired && !hasPhoneInput) {
//         setPhoneError(true);
//         return;
//       }
//       if (hasPhoneInput && !isValidPhoneNumber(phone)) {
//         setPhoneError(true);
//         return;
//       } else {
//         setPhoneError(false);
//       }

//       // persist as needed (but don't send a chat message for phone-only)
//       if (hasPhoneInput && typeof createUserPhone === 'function') {
//         createUserPhone(phone);
//       }
//       if (hasNameInput) createUserName(name.trim());
//       if (hasEmailInput) createUserEmail(email.trim());

//       setPhoneSubmitted(true);
//       setShowPhoneField(false);
//       setPhoneRequired(false);

//       // If user only gave phone (no text, no media) – capture it and stop here
//       if (!text && !pendingAudioData && preuploadedFiles.length === 0 && hasPhoneInput && !hasNameInput && !hasEmailInput) {
//         setPhone('');
//         return;
//       }
//     }

//     // Guard: if nothing to send
//     const hasAudio = Boolean(pendingAudioData);
//     const hasFiles = preuploadedFiles.length > 0;
//     const hasText = text.length > 0;
//     if (!hasText && !hasAudio && !hasFiles) return;

//     // Helper: package images/files json
//     const buildImagesOrFilesJson = () => {
//       if (preuploadedFiles.length === 0) return { images: [], files: [] };

//       const allImages = preuploadedFiles.every(it => it.base64Preview);
//       if (allImages) {
//         const images = preuploadedFiles.map(f => ({
//           size: `${f.sizeMB}`,
//           base64: f.base64Preview,
//           url: URL.createObjectURL(f.file),
//         }));
//         return { images, files: [] };
//       } else {
//         const files = preuploadedFiles.map(f => ({
//           fileName: f.name,
//           base64File: f.base64File,
//           extension: f.extension,
//           size: `${f.sizeMB}`,
//           url: URL.createObjectURL(f.file),
//         }));
//         return { images: [], files };
//       }
//     };

//     // FIRST SUBMIT: prefer a single UI image message (with text if present).
//     if (!firstMessageSent) {
//       const { images, files } = buildImagesOrFilesJson();

//       if (images.length > 0) {
//         const flags = images.length === 1
//           ? { isSimpleText: Boolean(text), isURL: false, isImageSingle: true,  isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//           : { isSimpleText: Boolean(text), isURL: false, isImageSingle: false, isImageGallery: true,  isAudio: false, isFile: false, isVideo: false, isHTML: false };

//         // ONE UI message: text + all images (provider will split per-image for socket)
//         const imgMsg = buildMessage(text, channelId, flags, { images });
//         sendMessage(imgMsg);

//         if (hasAudio) {
//           const audioMsg = buildMessage(
//             '',
//             channelId,
//             { ...(pendingAudioData?.flags || {}), isAudio: true, isSimpleText: false },
//             { ...(pendingAudioData?.jsonData || {}) }
//           );
//           sendMessage(audioMsg);
//         }

//         // housekeeping…
//         setFirstMessageSent(true);
//         setPendingAudioData(null);
//         setClearAudio(true);
//         setTimeout(() => setClearAudio(false), 0);
//         setAudioMessageSubmitted(true);
//         setPreuploadedFiles([]);
//         setClearUploader(true);
//         onRequestChange({ target: { value: '' } });
//         setUrlPreviewData(null);
//         setMessageFlags((old) => ({ ...old, isURL: false, isSimpleText: true }));
//         setName(''); setEmail(''); setPhone('');
//         return;
//       }

//       // No images → keep your existing files/text flow below (unchanged)...
//     }

//     // SUBSEQUENT SUBMITS (post-first): keep your existing behavior but ensure audio enables send
//     if (hasAudio) {
//       if (preuploadedFiles.length > 0) {
//         const { images, files } = buildImagesOrFilesJson();

//         if (images.length > 0) {
//           const flags = images.length === 1
//             ? { isSimpleText: Boolean(text), isURL: false, isImageSingle: true,  isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//             : { isSimpleText: Boolean(text), isURL: false, isImageSingle: false, isImageGallery: true,  isAudio: false, isFile: false, isVideo: false, isHTML: false };

//           // ONE UI message: text + all images; provider splits for socket
//           sendMessage(buildMessage(text, channelId, flags, { images }));
//         } else if (files.length > 0) {
//           sendMessage(buildMessage(
//             text,
//             channelId,
//             { isSimpleText: Boolean(text), isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: true, isVideo: false, isHTML: false },
//             files.length === 1
//               ? { url: files[0].url, fileName: files[0].fileName, extension: files[0].extension, size: files[0].size, base64File: files[0].base64File }
//               : { multipleFiles: files }
//           ));
//         } else if (hasText) {
//           // no media → pure text
//           sendMessage(buildMessage(
//             text,
//             channelId,
//             { isSimpleText: true, isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//           ));
//         }
//       } else if (hasText) {
//         // no uploads → text only before audio
//         sendMessage(buildMessage(
//           text,
//           channelId,
//           { isSimpleText: true, isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//         ));
//       }

//       // then audio
//       sendMessage(buildMessage(
//         '',
//         channelId,
//         { ...(pendingAudioData?.flags || {}), isAudio: true, isSimpleText: false },
//         { ...(pendingAudioData?.jsonData || {}) }
//       ));

//       // cleanup (as you already do)...
//       setPendingAudioData(null);
//       setClearAudio(true);
//       setTimeout(() => setClearAudio(false), 0);
//       setAudioMessageSubmitted(true);
//       setPreuploadedFiles([]);
//       setClearUploader(true);
//       onRequestChange({ target: { value: '' } });
//       return;
//     }

//     // No audio; just images/files or text
//     if (preuploadedFiles.length > 0) {
//       const { images, files } = buildImagesOrFilesJson();
//       if (images.length > 0) {
//         const flags = images.length === 1
//           ? { isSimpleText: Boolean(text), isURL: false, isImageSingle: true, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//           : { isSimpleText: Boolean(text), isURL: false, isImageSingle: false, isImageGallery: true, isAudio: false, isFile: false, isVideo: false, isHTML: false };
//         const msg = buildMessage(text, channelId, flags, { images });
//         sendMessage(msg);
//       } else if (files.length > 0) {
//         const msg = buildMessage(
//           text,
//           channelId,
//           { isSimpleText: Boolean(text), isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: true, isVideo: false, isHTML: false },
//           files.length === 1
//             ? { url: files[0].url, fileName: files[0].fileName, extension: files[0].extension, size: files[0].size, base64File: files[0].base64File }
//             : { multipleFiles: files }
//         );
//         sendMessage(msg);
//       }
//       setPreuploadedFiles([]);
//       setClearUploader(true);
//       onRequestChange({ target: { value: '' } });
//       return;
//     }

//   //   // pure text
//   //   if (hasText) {
//   //     const textMsg = buildMessage(
//   //       text,
//   //       channelId,
//   //       { isSimpleText: true, isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//   //     );
//   //     sendMessage(textMsg);
//   //     onRequestChange({ target: { value: '' } });
//   // };
//   // pure text
//     if (hasText) {
//       const textMsg = buildMessage(
//         text,
//         channelId,
//         { isSimpleText: true, isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
//       );
//       sendMessage(textMsg);
//       onRequestChange({ target: { value: '' } });
//       return; // ← prevent any legacy code below from running
//     }

//     // --------------------------------------------------
//     // C) If user hasn't yet submitted email (but no name in this case)
//     // --------------------------------------------------
//     if (needEmail && !hasEmailInput) {
//       // If showEmailField is on but user hasn't typed anything,
//       // or it was invalid, we either do nothing or show error
//       // depending on your UI preference:
//       setEmailError(true);
//       return;
//     }

//     // C2) If phone is required and not provided yet
//     if (needPhone && phoneRequired && !hasPhoneInput) {
//       setPhoneError(true);
//       return;
//     }
//     // C3) If phone is present but invalid
//     if (hasPhoneInput && !isValidPhoneNumber(phone)) {
//       setPhoneError(true);
//       return;
//     }

//     // --------------------------------------------------
//     // D) If user has preuploaded files, handle them
//     // --------------------------------------------------
//     if (preuploadedFiles.length > 0) {
//       // Decide if we are dealing with images or non-images
//       const allImages = preuploadedFiles.every(item => item.base64Preview);
//       if (allImages) {
//         // For images: single or gallery
//         if (preuploadedFiles.length === 1) {
//           setOnlyFlag('isImageSingle');

//           const singleImg = preuploadedFiles[0];
//           // Generate Blob URL
//           const blobUrl = URL.createObjectURL(singleImg.file);

//           const jsonData = {
//             images: [
//               {
//                 size: `${singleImg.sizeMB}`,
//                 base64: singleImg.base64Preview, // we keep the base64
//                 url: blobUrl,
//               }
//             ],
//           };

//           const newMessage = buildMessage(
//             request.trim(),
//             channelId,

//             { ...messageFlags, isImageSingle: true },
//             jsonData
//           );
//           sendMessage(newMessage);

//           setPhoneSubmitted(true);
//           setShowPhoneField(false);
//           setPhoneRequired(false);

//           setClearUploader(true);

//         } else {
//           setOnlyFlag('isImageGallery');
//           console.log('Flags: ', messageFlags)

//           const images = preuploadedFiles.map(f => ({
//             size: `${f.sizeMB}`,
//             base64: f.base64Preview,
//             url: URL.createObjectURL(f.file),
//           }));

//           const jsonData = { images };
//           const newMessage = buildMessage(
//             request.trim(),
//             channelId,
//             { ...messageFlags, isImageSingle: false, isImageGallery: true },
//             jsonData
//           );
//           sendMessage(newMessage);
//           setPhoneSubmitted(true);
//           setShowPhoneField(false);
//           setPhoneRequired(false);
//           setClearUploader(true);
//         }

//       } else {
//         // Non-images -> treat as 'file'
//         setOnlyFlag('isFile');

//         // Generate a blob URL for each file
//         const filesArray = preuploadedFiles.map((f) => {
//           const blobUrl = URL.createObjectURL(f.file);  // <--- generate blob link
//           return {
//             fileName: f.name,
//             extension: f.extension,
//             size: `${f.sizeMB}`,
//             url: blobUrl, // attach the blobUrl for this file
//             base64File: f.base64File, // attach the blobUrl for this file
//           };
//         });

//         // If there's only a single file, we can directly show url in the top-level
//         let singleFileUrl = filesArray.length === 1 ? filesArray[0].url : "";
//         let singleFileName = filesArray.length === 1 ? filesArray[0].fileName : "";
//         let singleFileExtension = filesArray.length === 1 ? filesArray[0].extension : "";
//         let singleFileSize = filesArray.length === 1 ? filesArray[0].size : "";
//         let singleFileBase64 = filesArray.length === 1 ? filesArray[0].base64File : "1";

//         // We'll store them in a single message (like a small 'file-list'):
//         const jsonData = {
//           // For convenience, set the top-level to the single file's URL if there's only 1
//           url: singleFileUrl,
//           fileName: singleFileName,
//           extension: singleFileExtension,
//           size: singleFileSize,
//           multipleFiles: filesArray,
//           base64File: singleFileBase64
//         };

//         const newMessage = buildMessage(
//           request.trim(),
//           channelId,
//           {
//             ...messageFlags,
//             isImageSingle: false,
//             isImageGallery: false,
//             isFile: true
//           },
//           jsonData
//         );
//         sendMessage(newMessage);
//         setPhoneSubmitted(true);
//         setShowPhoneField(false);
//         setPhoneRequired(false);
//         // Clear out the selected files in ChatInput’s state

//         setClearUploader(true);
//       }

//       // Clear out the selected files
//       setPreuploadedFiles([]);
//       onRequestChange({ target: { value: '' } });
//       setUrlPreviewData(null);
//       setMessageFlags((oldFlags) => ({ ...oldFlags, isURL: false, isSimpleText: true }));
//       return;
//     }

//     // 4. If it's just normal text (or text with URL, but no files)

//     if (request.trim() !== '') {
//       // 1) Detect URL:
//       const foundUrl = detectURLInText(request.trim());

//       // 2) Prepare a *local* newFlags object based on what we discover:
//       let newFlags;
//       let jsonData = {};

//       if (foundUrl && !urlPreviewData) {
//         const metaData = await fetchURLMetadata(foundUrl);
//         if (metaData) {
//           // define newFlags for a URL
//           newFlags = {
//             isSimpleText: false,
//             isURL: true,
//             isImageSingle: false,
//             isImageGallery: false,
//             isAudio: false,
//             isFile: false,
//             isVideo: false,
//             isHTML: false,
//           };
//           setMessageFlags(newFlags); // update state so next render sees it
//           setUrlPreviewData({ ...metaData, url: foundUrl });
//           await new Promise(resolve => setTimeout(resolve, 1000));

//           jsonData = {
//             url: foundUrl,
//             image: metaData.image,
//             description: metaData.description,
//             title: metaData.title,
//           };
//         } else {
//           // If meta fetch fails, default to simple text:
//           newFlags = {
//             isSimpleText: true,
//             isURL: false,
//             isImageSingle: false,
//             isImageGallery: false,
//             isAudio: false,
//             isFile: false,
//             isVideo: false,
//             isHTML: false,
//           };
//           setMessageFlags(newFlags);
//         }
//       } else if (urlPreviewData) {
//         // If we already have urlPreviewData from typing
//         newFlags = {
//           isSimpleText: false,
//           isURL: true,
//           isImageSingle: false,
//           isImageGallery: false,
//           isAudio: false,
//           isFile: false,
//           isVideo: false,
//           isHTML: false,
//         };
//         setMessageFlags(newFlags);
//         jsonData = {
//           url: urlPreviewData.url,
//           image: urlPreviewData.image,
//           description: urlPreviewData.description,
//           title: urlPreviewData.title,
//         };
//       } else {
//         // No URL -> simple text
//         newFlags = {
//           isSimpleText: true,
//           isURL: false,
//           isImageSingle: false,
//           isImageGallery: false,
//           isAudio: false,
//           isFile: false,
//           isVideo: false,
//           isHTML: false,
//         };
//         setMessageFlags(newFlags);
//       }

//       // 3) Now build and send using the *local* newFlags (not the old messageFlags!)
//       const newMessage = buildMessage(
//         request.trim(),
//         channelId,
//         newFlags, // <--- pass the local flags
//         jsonData
//       );
//       sendMessage(newMessage);
//       setPhoneSubmitted(true);
//       setShowPhoneField(false);
//       setPhoneRequired(false);

//       // Clean up
//       onRequestChange({ target: { value: '' } });
//       setUrlPreviewData(null);
//     }
//   };

//   // ======================= BUILD MESSAGE =======================
//   const generateTimestamp = () => {
//     return new Date().toISOString();
//   };

//   const determineMessageType = (flags) => {
//     if (flags.isURL) return "url";
//     if (flags.isImageSingle) return "image-single";
//     if (flags.isImageGallery) return "image-gallery";
//     if (flags.isAudio) return "audio";
//     if (flags.isFile) return "file";
//     if (flags.isVideo) return "video";
//     if (flags.isHTML) return "HTML";
//     if (flags.isSimpleText) return "simple_text";
//     return "simple_text";
//   };

//   const buildMessage = (requestText, chatId, flags, jsonData = {}) => {
//     const timestamp = generateTimestamp();

//     // Convert URLs in the text to <a> tags

//     let messageObj = {
//       id: `msg-${Date.now()}`,
//       sender: 'user',
//       user_name: name || userName, // Use the name from input if available for FirstMSG and cookie for next
//       user_phone: phone || userPhone,
//       text: requestText,      // <<-- includes <a> if any URL found
//       timestamp,
//       chatId,
//       ...jsonData,
//     };

//     const type = determineMessageType(flags);
//     switch (type) {
//       case "url":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "url",
//           url: jsonData.url || "",
//           image: jsonData.image || defaultUrlImage,
//           description: jsonData.description || "",
//           title: jsonData.title || jsonData.url,
//         };
//         break;
//       case "image-single":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "image",
//           gallery: "false",
//           images: jsonData.images || [],
//         };
//         break;
//       case "image-gallery":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "image",
//           gallery: "true",
//           images: jsonData.images || [],
//         };
//         break;
//       case "audio":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "audio",
//           file: jsonData.file || "",
//           audioBlobUrl: jsonData.audioBlobUrl,
//           audioBinary: jsonData.audioBinary,
//           playbackTime: jsonData.playbackTime || "",
//           histogram: jsonData.histogram || [],
//         };
//         break;
//       case "file":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "file",
//           url: jsonData.url || "",
//           fileName: jsonData.fileName || "",
//           extension: jsonData.extension || "",
//           size: jsonData.size || "",
//           base64File: jsonData.base64File || "",
//         };
//         break;
//       case "video":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "video",
//           url: jsonData.url || "",
//           fileName: jsonData.fileName || "",
//           extension: jsonData.extension || "",
//           size: jsonData.size || "",
//           playbackTime: jsonData.playbackTime || "",
//         };
//         break;
//       case "HTML":
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "HTML",
//           code: jsonData.code || "",
//         };
//         break;
//       default:
//         messageObj = {
//           ...messageObj,
//           typeOfMedia: "simple_text",
//         };
//         break;
//     }
//     return messageObj;
//   };

//   // ======================= Emoji Picker =======================
//   const toggleEmojiPicker = () => setIsEmojiPickerOpen(prev => !prev);
//   const onEmojiClick = (emojiData) => {
//     onRequestChange({ target: { value: request + emojiData.emoji } });
//     setIsEmojiPickerOpen(false);
//   };

//   // ======================= RENDER =======================
//   return (
//     <AnimatePresence>
//       {shouldRender && (
//         <motion.div
//           className="chat-input-container"
//           ref={inputContainerRef}
//           initial={{ opacity: 0, y: 10 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.3, ease: 'easeInOut' }}
//         >
//           <div className={`input-area ${inputFocused ? 'active' : ''}`}>

//             {isHydrated && showNameField && (
//               <div className={`name-input ${nameError ? 'error' : ''}`}>
//                 <input
//                   id="name"
//                   name="name"
//                   type="text"
//                   placeholder="Ваше ім'я"
//                   value={name}
//                   onFocus={() => {
//                     setNameError(false);
//                     setInputFocused(true);
//                   }}
//                   onBlur={onBlur}
//                   onChange={(e) => {
//                     setName(e.target.value);
//                     setNameError(false);
//                   }}
//                   onKeyDown={handleKeyDown}
//                 />
//                 {nameError && (
//                   <motion.span
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: 10 }}
//                     className="error-message"
//                   >
//                     Invalid name
//                   </motion.span>
//                 )}
//               </div>
//             )}

//             {isHydrated && showEmailField && (
//               <div className={`email-input ${emailError ? 'error' : ''}`}>
//                 <input
//                   id="email"
//                   name="email"
//                   type="text"
//                   placeholder="Email"
//                   value={email}
//                   onFocus={handleEmailFocus}
//                   onBlur={onBlur}
//                   onChange={(e) => {
//                     setEmail(e.target.value);
//                     setEmailError(false);
//                   }}
//                   onKeyDown={handleKeyDown}
//                 />
//                 {emailError && (
//                   <motion.span
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: 10 }}
//                     className="error-message"
//                   >
//                     Invalid email
//                   </motion.span>
//                 )}
//               </div>
//             )}

//             {isHydrated && showPhoneField && (
//               <div className={`phone-input ${phoneError ? 'error' : ''}`}>
//                 <div className='phone-title'>Телефон: </div>
//                 <PhoneInput
//                   id="phone"
//                   name="phone"
//                   value={phone}
//                   onChange={(val) => {
//                     setPhone(val || '');
//                     setPhoneError(false);
//                   }}
//                   defaultCountry="UA"
//                   international
//                   withCountryCallingCode
//                   placeholder=""
//                   onFocus={() => setInputFocused(true)}
//                   onBlur={onBlur}
//                   onKeyDown={handleKeyDown}
//                 />
//                 {phoneError && (
//                   <motion.span
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: 10 }}
//                     className="error-message"
//                   >
//                     Invalid phone
//                   </motion.span>
//                 )}
//               </div>
//             )}

//             <div className="request-input">
//               <textarea
//                 id="request"
//                 rows="1"
//                 value={request}
//                 onFocus={() => setInputFocused(true)}
//                 onBlur={onBlur}
//                 onChange={handleTextChange}
//                 onKeyDown={handleKeyDown}
//                 placeholder="Повідомлення..."
//               />
//             </div>

//             <div className="chat-toolbar">
//               <div className="chat-options">
//                 <div className='emozy'>
//                   <button className="emozy-button" onClick={toggleEmojiPicker}>
//                   </button>
//                 </div>
//                 {channelSettings?.allowImageMessages && (
//                   <FileUploader
//                     isImageUpload={true}
//                     multiple={true}
//                     maxFileSizeMB={5}
//                     maxImageSizeMB={5}
//                     allFormatsAllowed={false}
//                     allowedFormats={['jpg', 'jpeg', 'png', 'webm', 'heic']}
//                     onFilesChange={(files) => {
//                       setPreuploadedFiles(files);
//                     }}
//                     clearUploader={clearUploader}
//                     setClearUploader={setClearUploader}
//                   />
//                 )}
//                 {channelSettings?.allowFileUpload && (
//                   <FileUploader
//                     multiple={false}
//                     maxFileSizeMB={2}
//                     maxImageSizeMB={2}
//                     allFormatsAllowed={false}
//                     allowedFormats={['pdf']}
//                     onFilesChange={(files) => {
//                       setPreuploadedFiles(files);
//                     }}
//                     clearUploader={clearUploader}
//                     setClearUploader={setClearUploader}
//                   />
//                 )}
//                 {channelSettings?.allowAudioMessages && (
//                   <AudioMessageRecorder
//                     onClose={() => setShowRecorder(false)}
//                     setIsButtonEnabled={setIsButtonEnabled}
//                     buildMessage={buildMessage}
//                     audioMessageSubmitted={audioMessageSubmitted}
//                     setAudioMessageSubmitted={setAudioMessageSubmitted}
//                     onAudioRecorded={({ flags, jsonData }) => {
//                       setPendingAudioData({ flags, jsonData });
//                       // Enable the submit button when audio data is ready.
//                       setIsButtonEnabled(true);
//                     }}
//                     onAudioDeleted={() => {
//                       // remove the stale audio so the button state recomputes correctly
//                       setPendingAudioData(null);
//                     }}
//                     clearAudio={clearAudio}
//                     setClearUploader={setClearUploader}
//                   />
//                 )}
//               </div>
//               <div className="submit-button-container">
//                 <button
//                   className={`submit-button ${isButtonEnabled ? 'active' : ''}`}
//                   onClick={handleSubmit}
//                   disabled={!isButtonEnabled}
//                 ></button>
//               </div>
//             </div>

//             {isEmojiPickerOpen && (
//               <div className="emoji-picker-container">
//                 <EmojiPicker
//                   onEmojiClick={onEmojiClick}
//                   autoFocusSearch={false}
//                   emojiStyle="apple"
//                   height={261}
//                   width={348}
//                   previewConfig={{ showPreview: false }}
//                   skinTonesDisabled={true}
//                 />
//               </div>
//             )}
//           </div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };

// export default ChatInputContainer;

import { useState, useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import EmojiPicker from 'emoji-picker-react';
import AudioMessageRecorder from './AudioMessageRecorder';
import defaultUrlImage from '../media/url-default.jpg';
import { find as linkifyFind } from 'linkifyjs';
import FileUploader from './FileUploader';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { useChatApi } from '../Services/ChatApiProvider';

const ChatInputContainer = ({ isChatActive, request, onBlur, onRequestChange }) => {
  const { channelId } = useParams();

  const {
    userName,
    userEmail,
    createUserName,
    createUserEmail,
    sendMessage,
    channelSettings,
    isOnline,
    userPhone,
    createUserPhone,
    isHydrated,
  } = useChatApi();

  const [isButtonEnabled, setIsButtonEnabled] = useState(true);
  const [pendingAudioData, setPendingAudioData] = useState(null);
  const [shouldRender, setShouldRender] = useState(false);

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [emailSubmitted, setEmailSubmitted] = useState(false);

  // ====================== Phone field functionality ====================
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [phoneSubmitted, setPhoneSubmitted] = useState(false);
  const [showPhoneField, setShowPhoneField] = useState(false);
  const [phoneRequired, setPhoneRequired] = useState(false);

  const inputContainerRef = useRef(null);

  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const [showRecorder, setShowRecorder] = useState(false);
  const [clearAudio, setClearAudio] = useState(false);
  const [audioMessageSubmitted, setAudioMessageSubmitted] = useState(false);

  // ---------------- NEW: For URL preview data ------------------
  const [urlPreviewData, setUrlPreviewData] = useState(null);
  // -------------------------------------------------------------

  // ---------- For pre-uploaded files [FileUploader Changes] ----------
  const [preuploadedFiles, setPreuploadedFiles] = useState([]);
  const [clearUploader, setClearUploader] = useState(false);

  const [firstMessageSent, setFirstMessageSent] = useState(false);

  // keep the button alive when new audio arrives (covers “subsequent audio” stuck case)
  useEffect(() => {
    if (pendingAudioData) setIsButtonEnabled(true);
  }, [pendingAudioData]);

  //  ====================== Name field functionality ====================
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState(false);
  const [nameSubmitted, setNameSubmitted] = useState(false);

  const specialCharRegex = /[<>\/\\[\]{}]+/; // Disallow these special symbols

  const [showNameField, setShowNameField] = useState(false);
  const [showEmailField, setShowEmailField] = useState(false);

  useEffect(() => {
    if (!isHydrated) return;
    if (userName && String(userName).trim().length > 0) {
      setNameSubmitted(true);
      setShowNameField(false);
    } else if (channelSettings?.requestName === true) {
      setShowNameField(true);
      setNameSubmitted(false);
    } else {
      setShowNameField(false);
      setNameSubmitted(false);
    }
  }, [isHydrated, channelSettings?.requestName, userName]);

  useEffect(() => {
    if (!isHydrated) return;
    if (userEmail && String(userEmail).trim().length > 0) {
      setEmailSubmitted(true);
      setShowEmailField(false);
    } else if (channelSettings?.requestEmail === true) {
      setShowEmailField(true);
      setEmailSubmitted(false);
    } else {
      setShowEmailField(false);
      setEmailSubmitted(false);
    }
  }, [isHydrated, channelSettings?.requestEmail, userEmail]);

  useEffect(() => {
    if (!isHydrated) return;
    if (userPhone && String(userPhone).trim().length > 0) {
      setPhoneSubmitted(true);
      setShowPhoneField(false);
      setPhoneRequired(false);
    } else {
      setShowPhoneField(Boolean(channelSettings?.requestPhone));
      setPhoneRequired(Boolean(channelSettings?.requirePhone));
      setPhoneSubmitted(false);
    }
  }, [isHydrated, channelSettings?.requestPhone, channelSettings?.requirePhone, userPhone]);

  // ======================= MESSAGE FLAGS =======================
  const [messageFlags, setMessageFlags] = useState({
    isSimpleText: true,
    isURL: false,
    isImageSingle: false,
    isImageGallery: false,
    isAudio: false,
    isFile: false,
    isVideo: false,
    isHTML: false,
  });

  const setOnlyFlag = (flagName) => {
    setMessageFlags({
      isSimpleText: false,
      isURL: false,
      isImageSingle: false,
      isImageGallery: false,
      isAudio: false,
      isFile: false,
      isVideo: false,
      isHTML: false,
      [flagName]: true,
    });
  };

  // ---------------------  Timed rendering logic  ----------------
  useEffect(() => {
    if (isChatActive && !shouldRender) {
      const delayTimer = setTimeout(() => {
        clearTimeout(delayTimer);
        setShouldRender(true);
      }, 400);
    } else if (!isChatActive) {
      setShouldRender(false);
    }
  }, [isChatActive, shouldRender]);

  const isMobileRef = useRef(false);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const iPadOS = /Macintosh/.test(ua) && 'ontouchend' in document; // iPadOS 13+ pretends to be Mac
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const touchWindows = /Windows/i.test(ua) && navigator.maxTouchPoints > 1;
    isMobileRef.current = mobileUA || iPadOS || touchWindows;
  }, []);

  // ---------------------  Clicking outside the input area -> remove "active"  ----------------
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputContainerRef.current && !inputContainerRef.current.contains(event.target)) {
        setInputFocused(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    let enabled = false;

    const hasText = request.trim() !== '';
    const hasName = (showNameField && name.trim() !== '' && !nameError) || !showNameField;
    const hasEmail = (showEmailField && email.trim() !== '' && !emailError) || !showEmailField;
    const hasAudio = pendingAudioData !== null;
    const hasFiles = preuploadedFiles.length > 0;
    // Phone gating (required vs optional)
    let hasPhone = true;
    if (showPhoneField) {
      if (phoneRequired) {
        hasPhone = isValidPhoneNumber(phone || '');
      } else {
        hasPhone = phone ? isValidPhoneNumber(phone) : true;
      }
    }

    if (
      isChatActive &&
      isOnline &&
      hasEmail &&
      hasName &&
      hasPhone &&
      (hasText || hasAudio || hasFiles)
    ) {
      enabled = true;
    }
    setIsButtonEnabled(enabled);
  }, [
    isChatActive,
    request,
    showEmailField,
    email,
    emailError,
    showNameField,
    name,
    nameError,
    pendingAudioData,
    preuploadedFiles,
    isOnline,
    showPhoneField,
    phone,
    phoneError,
    phoneRequired,
  ]);

  // ==================== URL DETECTION & METADATA ====================

  // 1. Detect any URL using linkifyjs' linkifyFind:
  const detectURLInText = (text) => {
    // linkifyFind returns an array of link objects, e.g. [{ type: 'url', value: 'https://...', href: '...' }, ...]
    const foundLinks = linkifyFind(text);
    // If at least one link object is found, return its "href" (the actual URL)
    if (foundLinks.length > 0) {
      return foundLinks[0].href; // e.g. "https://www.example.com"
    }
    return null;
  };

  // 2. Fetch metadata from remote site
  const fetchURLMetadata = async (url) => {
    try {
      const response = await fetch(url);
      // Might throw CORS error if site does not allow cross-origin fetch
      const html = await response.text();

      // DOMParser
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Attempt to grab an image
      let imageTag =
        doc.querySelector('meta[name="twitter:image"]') ||
        doc.querySelector('meta[property="og:image"]');
      let descriptionTag =
        doc.querySelector('meta[name="description"]') ||
        doc.querySelector('meta[property="og:description"]');
      let titleTag = doc.querySelector('title');

      const image = imageTag ? imageTag.getAttribute('content') : null;
      const description = descriptionTag ? descriptionTag.getAttribute('content') : null;
      const title = titleTag ? titleTag.innerText : null;

      console.log('Retrieved image tag: ', image);
      console.log('Retrieved description: ', description);
      console.log('Retrieved title: ', title);

      return { image, description, title };
    } catch (error) {
      console.warn('Fetching URL metadata failed:', error);
      return null;
    }
  };

  // 3. As user types, fetch metadata if a URL is found
  const handleTextChange = async (e) => {
    const newText = e.target.value;
    onRequestChange(e);

    const foundUrl = detectURLInText(newText);
    if (foundUrl) {
      const metaData = await fetchURLMetadata(foundUrl);

      if (metaData) {
        setUrlPreviewData({
          url: foundUrl,
          image: metaData.image,
          description: metaData.description,
          title: metaData.title,
        });
        setOnlyFlag('isURL');
      }
    } else {
      // If user changed text and the URL is gone, reset
      setUrlPreviewData(null);
      setMessageFlags((oldFlags) => ({ ...oldFlags, isURL: false, isSimpleText: true }));
    }
  };

  // ==================== SUBMIT (with small delay if needed) ====================
  const handleEmailFocus = () => {
    setEmailError(false);
    setInputFocused(true);
  };

  // -------------- (1) Utility: Slightly transform text to linkify URLs ----------

  // const handleKeyDown = (e) => {
  //   if (e.key === 'Enter' && !e.shiftKey) {
  //     e.preventDefault();
  //     if (isButtonEnabled) {
  //       handleSubmit();
  //     }
  //   }
  // };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      // On mobile: never submit on Enter.
      if (isMobileRef.current) {
        // In the textarea, allow the default newline insertion.
        if (e.target && e.target.tagName === 'TEXTAREA') return;

        // In single-line inputs on mobile, ignore Enter entirely.
        e.preventDefault();
        return;
      }

      // Desktop: Enter = send, Shift+Enter = newline (handled by not hitting this branch)
      e.preventDefault();
      if (isButtonEnabled) handleSubmit();
    }
  };

  const handleSubmit = async () => {
    // A. Pre-calc “need / has” for identity fields
    const needName = showNameField && !nameSubmitted;
    const needEmail = showEmailField && !emailSubmitted;
    const needPhone = showPhoneField && !phoneSubmitted;

    const hasNameInput = name.trim() !== '';
    const hasEmailInput = email.trim() !== '';
    const hasPhoneInput = Boolean(phone);
    const text = request.trim();

    // B. If identity fields are requested and user typed something, validate & persist
    if (
      (needName || needEmail || needPhone) &&
      (hasNameInput ||
        hasEmailInput ||
        hasPhoneInput ||
        text ||
        pendingAudioData ||
        preuploadedFiles.length > 0)
    ) {
      // name
      if (hasNameInput && specialCharRegex.test(name)) {
        setNameError(true);
        return;
      } else {
        setNameError(false);
      }

      // email
      if (hasEmailInput) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
          setEmailError(true);
          return;
        } else {
          setEmailError(false);
        }
      }

      // phone
      if (needPhone && phoneRequired && !hasPhoneInput) {
        setPhoneError(true);
        return;
      }
      if (hasPhoneInput && !isValidPhoneNumber(phone)) {
        setPhoneError(true);
        return;
      } else {
        setPhoneError(false);
      }

      // persist as needed (but don't send a chat message for phone-only)
      if (hasPhoneInput && typeof createUserPhone === 'function') {
        createUserPhone(phone);
      }
      if (hasNameInput) createUserName(name.trim());
      if (hasEmailInput) createUserEmail(email.trim());

      setPhoneSubmitted(true);
      setShowPhoneField(false);
      setPhoneRequired(false);

      // If user only gave phone (no text, no media) – capture it and stop here
      if (
        !text &&
        !pendingAudioData &&
        preuploadedFiles.length === 0 &&
        hasPhoneInput &&
        !hasNameInput &&
        !hasEmailInput
      ) {
        setPhone('');
        return;
      }
    }

    // Guard: if nothing to send
    const hasAudio = Boolean(pendingAudioData);
    const hasFiles = preuploadedFiles.length > 0;
    const hasText = text.length > 0;
    if (!hasText && !hasAudio && !hasFiles) return;

    // Helper: package images/files json
    const buildImagesOrFilesJson = () => {
      if (preuploadedFiles.length === 0) return { images: [], files: [] };

      const allImages = preuploadedFiles.every((it) => it.base64Preview);
      if (allImages) {
        const images = preuploadedFiles.map((f) => ({
          size: `${f.sizeMB}`,
          base64: f.base64Preview,
          url: URL.createObjectURL(f.file),
        }));
        return { images, files: [] };
      } else {
        const files = preuploadedFiles.map((f) => ({
          fileName: f.name,
          base64File: f.base64File,
          extension: f.extension,
          size: `${f.sizeMB}`,
          url: URL.createObjectURL(f.file),
        }));
        return { images: [], files };
      }
    };

    // FIRST SUBMIT: prefer a single UI image message (with text if present).
    if (!firstMessageSent) {
      const { images, files } = buildImagesOrFilesJson();

      if (images.length > 0) {
        const flags =
          images.length === 1
            ? {
                isSimpleText: Boolean(text),
                isURL: false,
                isImageSingle: true,
                isImageGallery: false,
                isAudio: false,
                isFile: false,
                isVideo: false,
                isHTML: false,
              }
            : {
                isSimpleText: Boolean(text),
                isURL: false,
                isImageSingle: false,
                isImageGallery: true,
                isAudio: false,
                isFile: false,
                isVideo: false,
                isHTML: false,
              };

        // ONE UI message: text + all images (provider will split per-image for socket)
        const imgMsg = buildMessage(text, channelId, flags, { images });
        sendMessage(imgMsg);

        if (hasAudio) {
          const audioMsg = buildMessage(
            '',
            channelId,
            { ...(pendingAudioData?.flags || {}), isAudio: true, isSimpleText: false },
            { ...(pendingAudioData?.jsonData || {}) },
          );
          sendMessage(audioMsg);
        }

        // housekeeping…
        setFirstMessageSent(true);
        setPendingAudioData(null);
        setClearAudio(true);
        setTimeout(() => setClearAudio(false), 0);
        setAudioMessageSubmitted(true);
        setPreuploadedFiles([]);
        setClearUploader(true);
        onRequestChange({ target: { value: '' } });
        setUrlPreviewData(null);
        setMessageFlags((old) => ({ ...old, isURL: false, isSimpleText: true }));
        setName('');
        setEmail('');
        setPhone('');
        return;
      }

      // No images → keep your existing files/text flow below (unchanged)...
    }

    // SUBSEQUENT SUBMITS (post-first): keep your existing behavior but ensure audio enables send
    if (hasAudio) {
      if (preuploadedFiles.length > 0) {
        const { images, files } = buildImagesOrFilesJson();

        if (images.length > 0) {
          const flags =
            images.length === 1
              ? {
                  isSimpleText: Boolean(text),
                  isURL: false,
                  isImageSingle: true,
                  isImageGallery: false,
                  isAudio: false,
                  isFile: false,
                  isVideo: false,
                  isHTML: false,
                }
              : {
                  isSimpleText: Boolean(text),
                  isURL: false,
                  isImageSingle: false,
                  isImageGallery: true,
                  isAudio: false,
                  isFile: false,
                  isVideo: false,
                  isHTML: false,
                };

          // ONE UI message: text + all images; provider splits for socket
          sendMessage(buildMessage(text, channelId, flags, { images }));
        } else if (files.length > 0) {
          sendMessage(
            buildMessage(
              text,
              channelId,
              {
                isSimpleText: Boolean(text),
                isURL: false,
                isImageSingle: false,
                isImageGallery: false,
                isAudio: false,
                isFile: true,
                isVideo: false,
                isHTML: false,
              },
              files.length === 1
                ? {
                    url: files[0].url,
                    fileName: files[0].fileName,
                    extension: files[0].extension,
                    size: files[0].size,
                    base64File: files[0].base64File,
                  }
                : { multipleFiles: files },
            ),
          );
        } else if (hasText) {
          // no media → pure text
          sendMessage(
            buildMessage(text, channelId, {
              isSimpleText: true,
              isURL: false,
              isImageSingle: false,
              isImageGallery: false,
              isAudio: false,
              isFile: false,
              isVideo: false,
              isHTML: false,
            }),
          );
        }
      } else if (hasText) {
        // no uploads → text only before audio
        sendMessage(
          buildMessage(text, channelId, {
            isSimpleText: true,
            isURL: false,
            isImageSingle: false,
            isImageGallery: false,
            isAudio: false,
            isFile: false,
            isVideo: false,
            isHTML: false,
          }),
        );
      }

      // then audio
      sendMessage(
        buildMessage(
          '',
          channelId,
          { ...(pendingAudioData?.flags || {}), isAudio: true, isSimpleText: false },
          { ...(pendingAudioData?.jsonData || {}) },
        ),
      );

      // cleanup (as you already do)...
      setPendingAudioData(null);
      setClearAudio(true);
      setTimeout(() => setClearAudio(false), 0);
      setAudioMessageSubmitted(true);
      setPreuploadedFiles([]);
      setClearUploader(true);
      onRequestChange({ target: { value: '' } });
      return;
    }

    // No audio; just images/files or text
    if (preuploadedFiles.length > 0) {
      const { images, files } = buildImagesOrFilesJson();
      if (images.length > 0) {
        const flags =
          images.length === 1
            ? {
                isSimpleText: Boolean(text),
                isURL: false,
                isImageSingle: true,
                isImageGallery: false,
                isAudio: false,
                isFile: false,
                isVideo: false,
                isHTML: false,
              }
            : {
                isSimpleText: Boolean(text),
                isURL: false,
                isImageSingle: false,
                isImageGallery: true,
                isAudio: false,
                isFile: false,
                isVideo: false,
                isHTML: false,
              };
        const msg = buildMessage(text, channelId, flags, { images });
        sendMessage(msg);
      } else if (files.length > 0) {
        const msg = buildMessage(
          text,
          channelId,
          {
            isSimpleText: Boolean(text),
            isURL: false,
            isImageSingle: false,
            isImageGallery: false,
            isAudio: false,
            isFile: true,
            isVideo: false,
            isHTML: false,
          },
          files.length === 1
            ? {
                url: files[0].url,
                fileName: files[0].fileName,
                extension: files[0].extension,
                size: files[0].size,
                base64File: files[0].base64File,
              }
            : { multipleFiles: files },
        );
        sendMessage(msg);
      }
      setPreuploadedFiles([]);
      setClearUploader(true);
      onRequestChange({ target: { value: '' } });
      return;
    }

    //   // pure text
    //   if (hasText) {
    //     const textMsg = buildMessage(
    //       text,
    //       channelId,
    //       { isSimpleText: true, isURL: false, isImageSingle: false, isImageGallery: false, isAudio: false, isFile: false, isVideo: false, isHTML: false }
    //     );
    //     sendMessage(textMsg);
    //     onRequestChange({ target: { value: '' } });
    // };
    // pure text
    if (hasText) {
      const textMsg = buildMessage(text, channelId, {
        isSimpleText: true,
        isURL: false,
        isImageSingle: false,
        isImageGallery: false,
        isAudio: false,
        isFile: false,
        isVideo: false,
        isHTML: false,
      });
      sendMessage(textMsg);
      onRequestChange({ target: { value: '' } });
      return; // ← prevent any legacy code below from running
    }

    // --------------------------------------------------
    // C) If user hasn't yet submitted email (but no name in this case)
    // --------------------------------------------------
    if (needEmail && !hasEmailInput) {
      // If showEmailField is on but user hasn't typed anything,
      // or it was invalid, we either do nothing or show error
      // depending on your UI preference:
      setEmailError(true);
      return;
    }

    // C2) If phone is required and not provided yet
    if (needPhone && phoneRequired && !hasPhoneInput) {
      setPhoneError(true);
      return;
    }
    // C3) If phone is present but invalid
    if (hasPhoneInput && !isValidPhoneNumber(phone)) {
      setPhoneError(true);
      return;
    }

    // --------------------------------------------------
    // D) If user has preuploaded files, handle them
    // --------------------------------------------------
    if (preuploadedFiles.length > 0) {
      // Decide if we are dealing with images or non-images
      const allImages = preuploadedFiles.every((item) => item.base64Preview);
      if (allImages) {
        // For images: single or gallery
        if (preuploadedFiles.length === 1) {
          setOnlyFlag('isImageSingle');

          const singleImg = preuploadedFiles[0];
          // Generate Blob URL
          const blobUrl = URL.createObjectURL(singleImg.file);

          const jsonData = {
            images: [
              {
                size: `${singleImg.sizeMB}`,
                base64: singleImg.base64Preview, // we keep the base64
                url: blobUrl,
              },
            ],
          };

          const newMessage = buildMessage(
            request.trim(),
            channelId,

            { ...messageFlags, isImageSingle: true },
            jsonData,
          );
          sendMessage(newMessage);

          setPhoneSubmitted(true);
          setShowPhoneField(false);
          setPhoneRequired(false);

          setClearUploader(true);
        } else {
          setOnlyFlag('isImageGallery');
          console.log('Flags: ', messageFlags);

          const images = preuploadedFiles.map((f) => ({
            size: `${f.sizeMB}`,
            base64: f.base64Preview,
            url: URL.createObjectURL(f.file),
          }));

          const jsonData = { images };
          const newMessage = buildMessage(
            request.trim(),
            channelId,
            { ...messageFlags, isImageSingle: false, isImageGallery: true },
            jsonData,
          );
          sendMessage(newMessage);
          setPhoneSubmitted(true);
          setShowPhoneField(false);
          setPhoneRequired(false);
          setClearUploader(true);
        }
      } else {
        // Non-images -> treat as 'file'
        setOnlyFlag('isFile');

        // Generate a blob URL for each file
        const filesArray = preuploadedFiles.map((f) => {
          const blobUrl = URL.createObjectURL(f.file); // <--- generate blob link
          return {
            fileName: f.name,
            extension: f.extension,
            size: `${f.sizeMB}`,
            url: blobUrl, // attach the blobUrl for this file
            base64File: f.base64File, // attach the blobUrl for this file
          };
        });

        // If there's only a single file, we can directly show url in the top-level
        let singleFileUrl = filesArray.length === 1 ? filesArray[0].url : '';
        let singleFileName = filesArray.length === 1 ? filesArray[0].fileName : '';
        let singleFileExtension = filesArray.length === 1 ? filesArray[0].extension : '';
        let singleFileSize = filesArray.length === 1 ? filesArray[0].size : '';
        let singleFileBase64 = filesArray.length === 1 ? filesArray[0].base64File : '1';

        // We'll store them in a single message (like a small 'file-list'):
        const jsonData = {
          // For convenience, set the top-level to the single file's URL if there's only 1
          url: singleFileUrl,
          fileName: singleFileName,
          extension: singleFileExtension,
          size: singleFileSize,
          multipleFiles: filesArray,
          base64File: singleFileBase64,
        };

        const newMessage = buildMessage(
          request.trim(),
          channelId,
          {
            ...messageFlags,
            isImageSingle: false,
            isImageGallery: false,
            isFile: true,
          },
          jsonData,
        );
        sendMessage(newMessage);
        setPhoneSubmitted(true);
        setShowPhoneField(false);
        setPhoneRequired(false);
        // Clear out the selected files in ChatInput’s state

        setClearUploader(true);
      }

      // Clear out the selected files
      setPreuploadedFiles([]);
      onRequestChange({ target: { value: '' } });
      setUrlPreviewData(null);
      setMessageFlags((oldFlags) => ({ ...oldFlags, isURL: false, isSimpleText: true }));
      return;
    }

    // 4. If it's just normal text (or text with URL, but no files)

    if (request.trim() !== '') {
      // 1) Detect URL:
      const foundUrl = detectURLInText(request.trim());

      // 2) Prepare a *local* newFlags object based on what we discover:
      let newFlags;
      let jsonData = {};

      if (foundUrl && !urlPreviewData) {
        const metaData = await fetchURLMetadata(foundUrl);
        if (metaData) {
          // define newFlags for a URL
          newFlags = {
            isSimpleText: false,
            isURL: true,
            isImageSingle: false,
            isImageGallery: false,
            isAudio: false,
            isFile: false,
            isVideo: false,
            isHTML: false,
          };
          setMessageFlags(newFlags); // update state so next render sees it
          setUrlPreviewData({ ...metaData, url: foundUrl });
          await new Promise((resolve) => setTimeout(resolve, 1000));

          jsonData = {
            url: foundUrl,
            image: metaData.image,
            description: metaData.description,
            title: metaData.title,
          };
        } else {
          // If meta fetch fails, default to simple text:
          newFlags = {
            isSimpleText: true,
            isURL: false,
            isImageSingle: false,
            isImageGallery: false,
            isAudio: false,
            isFile: false,
            isVideo: false,
            isHTML: false,
          };
          setMessageFlags(newFlags);
        }
      } else if (urlPreviewData) {
        // If we already have urlPreviewData from typing
        newFlags = {
          isSimpleText: false,
          isURL: true,
          isImageSingle: false,
          isImageGallery: false,
          isAudio: false,
          isFile: false,
          isVideo: false,
          isHTML: false,
        };
        setMessageFlags(newFlags);
        jsonData = {
          url: urlPreviewData.url,
          image: urlPreviewData.image,
          description: urlPreviewData.description,
          title: urlPreviewData.title,
        };
      } else {
        // No URL -> simple text
        newFlags = {
          isSimpleText: true,
          isURL: false,
          isImageSingle: false,
          isImageGallery: false,
          isAudio: false,
          isFile: false,
          isVideo: false,
          isHTML: false,
        };
        setMessageFlags(newFlags);
      }

      // 3) Now build and send using the *local* newFlags (not the old messageFlags!)
      const newMessage = buildMessage(
        request.trim(),
        channelId,
        newFlags, // <--- pass the local flags
        jsonData,
      );
      sendMessage(newMessage);
      setPhoneSubmitted(true);
      setShowPhoneField(false);
      setPhoneRequired(false);

      // Clean up
      onRequestChange({ target: { value: '' } });
      setUrlPreviewData(null);
    }
  };

  // ======================= BUILD MESSAGE =======================
  const generateTimestamp = () => {
    return new Date().toISOString();
  };

  const determineMessageType = (flags) => {
    if (flags.isURL) return 'url';
    if (flags.isImageSingle) return 'image-single';
    if (flags.isImageGallery) return 'image-gallery';
    if (flags.isAudio) return 'audio';
    if (flags.isFile) return 'file';
    if (flags.isVideo) return 'video';
    if (flags.isHTML) return 'HTML';
    if (flags.isSimpleText) return 'simple_text';
    return 'simple_text';
  };

  const buildMessage = (requestText, chatId, flags, jsonData = {}) => {
    const timestamp = generateTimestamp();

    // Convert URLs in the text to <a> tags

    let messageObj = {
      id: `msg-${Date.now()}`,
      sender: 'user',
      user_name: name || userName, // Use the name from input if available for FirstMSG and cookie for next
      user_phone: phone || userPhone,
      text: requestText, // <<-- includes <a> if any URL found
      timestamp,
      chatId,
      ...jsonData,
    };

    const type = determineMessageType(flags);
    switch (type) {
      case 'url':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'url',
          url: jsonData.url || '',
          image: jsonData.image || defaultUrlImage,
          description: jsonData.description || '',
          title: jsonData.title || jsonData.url,
        };
        break;
      case 'image-single':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'image',
          gallery: 'false',
          images: jsonData.images || [],
        };
        break;
      case 'image-gallery':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'image',
          gallery: 'true',
          images: jsonData.images || [],
        };
        break;
      case 'audio':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'audio',
          file: jsonData.file || '',
          audioBlobUrl: jsonData.audioBlobUrl,
          audioBinary: jsonData.audioBinary,
          playbackTime: jsonData.playbackTime || '',
          histogram: jsonData.histogram || [],
        };
        break;
      case 'file':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'file',
          url: jsonData.url || '',
          fileName: jsonData.fileName || '',
          extension: jsonData.extension || '',
          size: jsonData.size || '',
          base64File: jsonData.base64File || '',
        };
        break;
      case 'video':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'video',
          url: jsonData.url || '',
          fileName: jsonData.fileName || '',
          extension: jsonData.extension || '',
          size: jsonData.size || '',
          playbackTime: jsonData.playbackTime || '',
        };
        break;
      case 'HTML':
        messageObj = {
          ...messageObj,
          typeOfMedia: 'HTML',
          code: jsonData.code || '',
        };
        break;
      default:
        messageObj = {
          ...messageObj,
          typeOfMedia: 'simple_text',
        };
        break;
    }
    return messageObj;
  };

  // ======================= Emoji Picker =======================
  const toggleEmojiPicker = () => setIsEmojiPickerOpen((prev) => !prev);
  const onEmojiClick = (emojiData) => {
    onRequestChange({ target: { value: request + emojiData.emoji } });
    setIsEmojiPickerOpen(false);
  };
  // ======================= RENDER =======================
  return (
    <AnimatePresence>
      {shouldRender && (
        <motion.div
          className="chat-input-container"
          ref={inputContainerRef}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <div className={`input-area ${inputFocused ? 'active' : ''}`}>
            {isHydrated && showNameField && (
              <div className={`name-input ${nameError ? 'error' : ''}`}>
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Ваше ім'я"
                  value={name}
                  onFocus={() => {
                    setNameError(false);
                    setInputFocused(true);
                  }}
                  onBlur={onBlur}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameError(false);
                  }}
                  onKeyDown={handleKeyDown}
                />
                {nameError && (
                  <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    className="error-message"
                  >
                    Invalid name
                  </motion.span>
                )}
              </div>
            )}

            {isHydrated && showEmailField && (
              <div className={`email-input ${emailError ? 'error' : ''}`}>
                <input
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Email"
                  value={email}
                  onFocus={handleEmailFocus}
                  onBlur={onBlur}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(false);
                  }}
                  onKeyDown={handleKeyDown}
                />
                {emailError && (
                  <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    className="error-message"
                  >
                    Invalid email
                  </motion.span>
                )}
              </div>
            )}

            {isHydrated && showPhoneField && (
              <div className={`phone-input ${phoneError ? 'error' : ''}`}>
                <div className="phone-title">Телефон: </div>
                <PhoneInput
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={(val) => {
                    setPhone(val || '');
                    setPhoneError(false);
                  }}
                  defaultCountry="UA"
                  international
                  withCountryCallingCode
                  placeholder=""
                  onFocus={() => setInputFocused(true)}
                  onBlur={onBlur}
                  onKeyDown={handleKeyDown}
                />
                {phoneError && (
                  <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    className="error-message"
                  >
                    Invalid phone
                  </motion.span>
                )}
              </div>
            )}

            <div className="request-input">
              <textarea
                id="request"
                rows="1"
                value={request}
                onFocus={() => setInputFocused(true)}
                onBlur={onBlur}
                onChange={handleTextChange}
                onKeyDown={handleKeyDown}
                placeholder={channelSettings.input_placeholder_text || 'Type a message...'}
              />
            </div>

            <div className="chat-toolbar">
              <div className="chat-options">
                <div className="emozy">
                  <button className="emozy-button" onClick={toggleEmojiPicker}></button>
                </div>
                {channelSettings?.allowImageMessages && (
                  <FileUploader
                    isImageUpload={true}
                    multiple={true}
                    maxFileSizeMB={5}
                    maxImageSizeMB={5}
                    allFormatsAllowed={false}
                    allowedFormats={['jpg', 'jpeg', 'png', 'webm', 'heic']}
                    onFilesChange={(files) => {
                      setPreuploadedFiles(files);
                    }}
                    clearUploader={clearUploader}
                    setClearUploader={setClearUploader}
                  />
                )}
                {channelSettings?.allowFileUpload && (
                  <FileUploader
                    multiple={false}
                    maxFileSizeMB={10}
                    maxImageSizeMB={2}
                    allFormatsAllowed={false}
                    allowedFormats={['pdf', 'mp4', 'webm', 'mov', 'zip', 'ogg', 'opus']}
                    onFilesChange={(files) => {
                      setPreuploadedFiles(files);
                    }}
                    clearUploader={clearUploader}
                    setClearUploader={setClearUploader}
                  />
                )}
                {channelSettings?.allowAudioMessages && (
                  <AudioMessageRecorder
                    onClose={() => setShowRecorder(false)}
                    setIsButtonEnabled={setIsButtonEnabled}
                    buildMessage={buildMessage}
                    audioMessageSubmitted={audioMessageSubmitted}
                    setAudioMessageSubmitted={setAudioMessageSubmitted}
                    onAudioRecorded={({ flags, jsonData }) => {
                      setPendingAudioData({ flags, jsonData });
                      // Enable the submit button when audio data is ready.
                      setIsButtonEnabled(true);
                    }}
                    onAudioDeleted={() => {
                      // remove the stale audio so the button state recomputes correctly
                      setPendingAudioData(null);
                    }}
                    clearAudio={clearAudio}
                    setClearUploader={setClearUploader}
                  />
                )}
              </div>
              <div className="submit-button-container">
                <button
                  className={`submit-button ${isButtonEnabled ? 'active' : ''}`}
                  onClick={handleSubmit}
                  disabled={!isButtonEnabled}
                ></button>
              </div>
            </div>

            {isEmojiPickerOpen && (
              <div className="emoji-picker-container">
                <EmojiPicker
                  onEmojiClick={onEmojiClick}
                  autoFocusSearch={false}
                  emojiStyle="apple"
                  height={261}
                  width={348}
                  previewConfig={{ showPreview: false }}
                  skinTonesDisabled={true}
                />
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ChatInputContainer;
